import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-proyecto-tarjeta',
  templateUrl: './proyecto-tarjeta.component.html',
  styleUrls: ['./proyecto-tarjeta.component.css']
})
export class ProyectoTarjetaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
